import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const Keywords = ({ cell }) => {
  const {
    column: { id: columnName },
    row: { original },
  } = cell;

  const location = useLocation();
  const language = columnName.split('_')[1];
  const count = original?.wordsets_count?.[language];

  const { t } = useTranslation(['promptbar']);

  return (
    <Box
      sx={{
        width: 'calc(100% - 10px)',
      }}
    >
      {count ? <span>{count}</span> : ''}

      <Box
        sx={{
          position: 'absolute',
          top: '2px',
          right: '2px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Tooltip arrow placement="right" title={t('promptbar:keywords')}>
          <Link
            to={`./keywords/${original.id}`}
            state={{ language, codeInfo: original, from: location }}
          >
            <IconButton
              size="sm"
              aria-label="keywords"
              sx={{
                bgcolor: 'var(--color-btn-light)',
                '&:hover': {
                  bgcolor: 'var(--color-primary)',
                  color: 'var(--color-white)',
                },
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: 'var(--font-size-m)',
                }}
              />
            </IconButton>
          </Link>
        </Tooltip>
      </Box>
    </Box>
  );
};

Keywords.propTypes = {
  cell: PropTypes.object.isRequired,
};

export default Keywords;
